function showPreloader(container) {
    let $container = $(container);

    if ($container.find('.preloader').length === 0) {
        let $preloader = $('<div>')
            .addClass('preloader')
            .text('Loading...');
        $container.append($preloader);
    }
}

function hidePreloader(container) {
    $(container).find('.preloader').remove();
}

function hideAllPreloaders() {
    $('.preloader').remove();
}

function buildFilterParams(filters = {}) {
  const params = new URLSearchParams();
  for (const [key, val] of Object.entries(filters)) {
    if (Array.isArray(val)) {
      for (const v of val) params.append(`filter[${key}][]`, v);
    } else if (val !== undefined && val !== null && val !== '') {
      params.append(`filter[${key}]`, val);
    }
  }
  return params.toString();
}

async function getPriceRange(filters = {}) {
    const qs = buildFilterParams(filters);
    const url = `${BASE_URL}/api/products/price-range/${qs ? `?${qs}` : ''}`;

    const res = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error(`Request failed: ${res.status} ${res.statusText}`);

    const json = await res.json();
    const payload = json?.data ?? json;
    return { minPrice: Number(payload.minPrice), maxPrice: Number(payload.maxPrice) };
}

async function getWeightRange(filters = {}) {
    const qs = buildFilterParams(filters);
    const url = `${BASE_URL}/api/products/weight-range/${qs ? `?${qs}` : ''}`;

    const res = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error(`Request failed: ${res.status} ${res.statusText}`);

    const json = await res.json();
    const payload = json?.data ?? json;
    return { minWeight: Number(payload.minWeight), maxWeight: Number(payload.maxWeight) };
}

async function getFilters(filters = {}) {
    const qs = buildFilterParams(filters);
    const url = `${BASE_URL}/api/filters/${qs ? `?${qs}` : ''}`;

    const res = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error(`Request failed: ${res.status} ${res.statusText}`);

    const json = await res.json();
    const payload = json?.data ?? json;
    return payload;
}

function buildQueryParams(params, prefix = '') {
    const qs = [];
    for (const key in params) {
        if (!params.hasOwnProperty(key)) continue;
        const value = params[key];
        const prefixedKey = prefix ? `${prefix}[${key}]` : key;

        if (Array.isArray(value)) {
            value.forEach(v => qs.push(`${encodeURIComponent(prefixedKey)}[]=${encodeURIComponent(v)}`));
        } else if (typeof value === 'object' && value !== null) {
            qs.push(buildQueryParams(value, prefixedKey));
        } else if (value !== undefined && value !== null) {
            qs.push(`${encodeURIComponent(prefixedKey)}=${encodeURIComponent(value)}`);
        }
    }
    return qs.join('&');
}

async function getProducts(productQuery = {}) {
    const qs = buildQueryParams(productQuery);
    const url = `${BASE_URL}/api/products/${qs ? `?${qs}` : ''}`;

    const res = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error(`Request failed: ${res.status} ${res.statusText}`);

    const json = await res.json();
    return json?.data ?? json;
}

async function loadProducts(productQuery = {}, clear = false) {
    showPreloader('.table-wrapper');   // показуємо прелоадер

    var products = await getProducts(productQuery);

    if (!products.length || products.length < 100) {
        hasMore = false;
    } else {
        hasMore = true;
    }

    if (clear) {
        $('#productTableBody').empty();
    }

    products.forEach(function(product) {
        product.variants.forEach(function(variant) {
            var p = new Product(variant, product);
            $('#productTableBody').append(p.tr);
        });
    });

    hidePreloader('.table-wrapper');   // ховаємо прелоадер
}

async function sortProducts(field, el) {
    if (!productQuery) {
        productQuery = {};
    }

    // Ініціалізація фільтрів
    if (!productQuery.filter) {
        productQuery.filter = {};
    }

    // Поточний порядок
    let currentOrder = $(el).attr("data-order") || "asc";
    let newOrder = currentOrder === "asc" ? "desc" : "asc";

    // Змінюємо атрибут data-order
    $(el).attr("data-order", newOrder);

    // Оновлюємо іконку
    let icon = $(el).find("i");
    if (newOrder === "asc") {
        icon.removeClass("icons-chevron-up").addClass("icons-chevron-down");
    } else {
        icon.removeClass("icons-chevron-down").addClass("icons-chevron-up");
    }

    // Додаємо параметри сортування в productQuery
    productQuery.sort = field;
    productQuery.sort_order = newOrder.toUpperCase(); // ASC або DESC

    // Скидаємо пагінацію
    page = 1;
    productQuery.page = page;

    console.log("Sorting by:", field, newOrder);

    // Завантажуємо товари
    await loadProducts(productQuery, true);

    // Скролимо таблицю на початок
    $('.table-wrapper > table').scrollTop(0);
}
